<script setup lang="ts">
import { computed, PropType } from 'vue'

import { defaultGme, Gme } from '@/store/modules/stay/smr/grouping/types'
import { RhsDashboardClass, RhsDashboardType } from '@/store/modules/stay/smr/types'

const props = defineProps({
  gme: {
    type: Object as PropType<Gme>,
    required: false,
    default: null
  },
  size: {
    validator(value: string) {
      return ['sm', 'md'].includes(value)
    },
    default: 'md'
  },
  hasError: {
    type: Boolean,
    default: false
  }
})

const displayedGme = computed(() => props.gme !== null ? props.gme : defaultGme())
const style = computed(() => `gme-reference-${props.size}`)
</script>

<template>
  <div
    v-tooltip="displayedGme.description"
    class="gme-reference row g-0"
    :class="[style, { 'gme-reference--error': hasError }]"
  >
    <div class="col">
      <div
        id="gme-diagnoses-level"
        class="dashboard"
        :class="RhsDashboardClass[RhsDashboardType.RHS_DASHBOARD_DIAGNOSES]"
      >
        <div class="dashboard__code">
          {{ displayedGme.gn || '????' }}
        </div>
      </div>
    </div>
    <div class="col">
      <div
        id="gme-csar-level"
        class="dashboard"
        :class="RhsDashboardClass[RhsDashboardType.RHS_DASHBOARD_ACT_CSARR]"
      >
        <div>{{ displayedGme.gr || '?' }}</div>
      </div>
    </div>
    <div class="col">
      <div
        id="gme-dependency-level"
        class="dashboard"
        :class="RhsDashboardClass[RhsDashboardType.RHS_DASHBOARD_DEPENDENCIES]"
      >
        <div>{{ displayedGme.gl || '?' }}</div>
      </div>
    </div>
    <div class="col">
      <div
        id="gme-severity-level"
        class="dashboard dashboard-severity"
      >
        <div>{{ displayedGme.level || '?' }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/design-system/tokens/colors';

.gme-reference {
  .dashboard {
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    text-align: center;
  }

  &-md {
    gap: 5px;
    font-size: 1.25em;

    .dashboard {
      padding: 5px 10px;
    }
  }

  &-sm {
    column-gap: 3px;
    font-size: 1em;

    .dashboard {
      min-width: 25px;
      padding: 0 2px;
    }
  }

  &--error {
    .dashboard {
      background: $grouping-badge-error-bg;
      border-color: $grouping-badge-error-bg;
    }
  }
}
</style>
